import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError, MASCOT } from "@/lib/api";
import { AuthShell, AuthField } from "@/components/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error("As senhas não conferem");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      toast.success("Senha alterada! Faça login.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Nova senha" subtitle="Escolha uma senha nova e segura." mascot={MASCOT.tilt}
      footer={<Link to="/login" className="text-[#f0791f] font-semibold">Voltar ao login</Link>}>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <AuthField label="Nova senha" testid="reset-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Mínimo 6 caracteres" required />
        <AuthField label="Confirmar senha" testid="reset-confirm" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} placeholder="Repita a senha" required />
        <button type="submit" disabled={loading} className="btn-orange w-full py-3.5 rounded-full font-semibold disabled:opacity-60" data-testid="reset-submit">
          {loading ? "Salvando..." : "Salvar nova senha"}
        </button>
      </form>
    </AuthShell>
  );
}
